export default __webpack_public_path__ + "static/media/memo.99e39a43.png";